import React from 'react';
import PageHeader from './components/PageHeader';
import SettingsPPMPaymentTerms from './SettingsPPMPaymentTerms';

function PPMPaymentTermsPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader
        title="PPM Payment Terms"
        subtitle="Configure payment terms for PPM contracts"
        backTo="/settings/finance"
        backLabel="Finance"
        sticky
      />
      <div className="p-6">
        <SettingsPPMPaymentTerms />
      </div>
    </div>
  );
}

export default PPMPaymentTermsPage;
